import {
  Grid,
  Box,
  Button,
  Image,
  Badge,
  Input,
  VStack,
  Heading,
  Text,
  Flex,
  Center,
  HStack,
  Spacer,
} from "@chakra-ui/react";

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { useState } from "react";

import ReactPlayer from "react-player";
import battletheme from "../audio/battletheme.wav";

const Header = () => {
  const [playAudio, setPlayAudio] = useState(false);

  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      wrap="wrap"
      align="center"
      p={8}
      bg="primary.500"
    >
      <Flex align="center">
        <Box>
          <Text fontSize="lg" fontWeight="bold">
            Welcome
          </Text>
        </Box>
        <Spacer />
        <HStack marginLeft={8} gap={8}>
          <Link to="/">
            <Button>Home</Button>
          </Link>
          <Link to="/shop">
            <Button>Shop</Button>
          </Link>
          <Link to="/abilities">
            <Button>Abilities</Button>
          </Link>
          <Box>
            <ReactPlayer
              url={battletheme}
              width="0px"
              height="0px"
              volume={0.1}
              playing={playAudio}
              loop={true}
            />
            <Button onClick={() => setPlayAudio(!playAudio)}>
              {playAudio ? "Pause Audio" : "Play Audio"}
            </Button>
          </Box>
        </HStack>
      </Flex>

      <Flex align="center" justifyContent="space-between">
        <Flex>Gold: 0</Flex>
      </Flex>
    </Flex>
  );
};

export default Header;
